<template>
  <v-form>
    <v-container v-if="GetBookedDetails() !== null">
      <v-col cols="12" class="mb-0 mt-0 pb-0 pt-0">
        <div class="text-h5 font-weight-medium" v-if="GetBookedDetails().paymentMode !== 'BankTransfer' 
        && GetBookedDetails().paymentMode !== 'PaymentPending'">
          Your Booking #: {{ GetBookedDetails() !== null ? GetBookedDetails().orderCode
          : '--------'
          }} is Confirmed.
          <!-- Your Booking from {{ formatDate(GetArrival()) }} to
          {{ formatDate(GetDeparture()) }} is Confirmed.  -->
          <br /> Booking Voucher will be sent to your email address provided.
        </div>
        <div class="text-h5 font-weight-medium" v-if="GetBookedDetails().paymentMode === 'BankTransfer' || GetBookedDetails().paymentMode === 'PaymentPending'">
          Your Booking #: {{ GetBookedDetails() !== null ? GetBookedDetails().orderCode
          : '--------'
          }} is on hold.
          <!-- Your Booking from {{ formatDate(GetArrival()) }} to
          {{ formatDate(GetDeparture()) }} is on hold.  -->
          <br /> Please make payment in accordance with hotel booking policy to confirm your booking.
        </div>
      </v-col>
      <v-row no-gutters class="mt-4">
        <v-col cols="12">
          <div class="text-h5 font-weight-black">Booking #:{{ GetBookedDetails() !== null ? GetBookedDetails().orderCode
          : '--------'
          }}</div>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">First Name:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.firstName }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Last Name:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.lastName }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Email:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.email }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Country:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails() !== null ?
        GetCountry(GetBookedDetails().beGuest.countryCode)().name : "Undefined" }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Phone:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.mobileNumber }}</v-col>
      </v-row>
      <v-row no-gutters class="mb-2">
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Special Request:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().notes }}</v-col>
      </v-row>

      <v-row no-gutters class="mt-4">
        <v-col lg="3" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Accomodation Total:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">
          <div class="text-subtitle-2 font-weight-black">{{ GetBookedDetails().displayGrandTotalAmount }}</div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="3" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Grand Total:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">
          <div class="text-subtitle-2 font-weight-black">{{ GetBookedDetails().displayGrandTotalAmount }}</div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="3" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Deposit:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">
          <div class="text-subtitle-2 font-weight-black">{{ GetBookedDetails().displayDepositAmount }}</div>
        </v-col>
      </v-row>
      <!-- <template v-for="(roomStay, iroomStay) in GetBookedDetails().beRoomStays">
        <v-row no-gutters class="mt-4" :key="iroomStay + 'roomName-col'">
          <v-col lg="2" md="4" sm="6" xs="12">
            <div class="text-subtitle-2">Room Name:</div>
          </v-col>
          <v-col lg="4" md="4" sm="6" xs="12">{{roomStay.beRoomType.name}}</v-col>
        </v-row>
        <v-row no-gutters :key="iroomStay + 'rateName-col'">
          <v-col lg="2" md="4" sm="6" xs="12">
            <div class="text-subtitle-2">Rate Name:</div>
          </v-col>
          <v-col lg="4" md="4" sm="6" xs="12">{{roomStay.beRoomTypeRatePlan.name}}</v-col>
        </v-row>
        <v-row no-gutters :key="iroomStay + 'occupancy-col'">
          <v-col lg="2" md="4" sm="6" xs="12">
            <div class="text-subtitle-2">Occupancy:</div>
          </v-col>
          <v-col lg="4" md="4" sm="6" xs="12"></v-col>
        </v-row>
      </template> -->
      <template v-for="(room, iroom) in GetBookedDetails().beRoomStays">
        <rate-breakdown :Room="room" :key="iroom + 'breakdown-section'"></rate-breakdown>

      </template>
      <!-- <v-col cols="12" class="d-block mb-0 mt-0 pb-0 pt-0">
        <div class="text-subtitle-2">Payment Method</div>
      </v-col>
      <v-col lg="4" md="4" sm="6" xs="12"> </v-col>
      <v-col cols="12">
        <div class="text-body-2 d-inline">Total Payment:</div>
        <div class="text-body-1 d-inline font-weight-black">S$15.00</div>
      </v-col>
      <v-divider></v-divider> -->
    </v-container>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

import RateBreakdown from '../Booking/RoomRateBreakdown.vue';

export default {
  props: {
    OrderCode: {
      type: String,
      require: false,
    }

  },
  components: {
    RateBreakdown
  },
  methods: {
    formatDate(date) {
      return moment(date).format("dddd Do MMMM YYYY");
    },
  },
  beforeMount: function () {

    // this.$store.dispatch("setPropertyCode", this.PropertyCode);

    this.$store.dispatch("getBookingDetailsById", this.OrderCode);
  },
  computed: {
    ...mapGetters([
      "GetArrival",
      "GetDeparture",
      "GetGuest",
      'GetBookingSummary',
      'GetBookingInfo',
      'GetBookedDetails',
      'GetCountry']),
  },
};
</script>